module.exports = __webpack_public_path__ + "img/award-bg-zh.a2a95ec5.png";